import _ from 'underscore';

import Schema from 'pages/open-course/peerReview/reviewTypes/structured/models/schema';

import type { ReviewSchema } from 'bundles/peer/types/Reviews';

/**
 * Given data of the form
 * {
 *   typeName: String,
 *   definition: any
 * }
 * constructs and returns the corresponding review schema.
 */
const schemaFactory = function (reviewSchema?: ReviewSchema): $TSFixMe {
  const schemaData: Partial<ReviewSchema> = reviewSchema || {};

  return new Schema(_({}).extend(schemaData.definition), { parse: true });
};

export default schemaFactory;
